import React, { Fragment, Component } from 'react'
import Select from 'react-select'
import {
    Container,
    Row, Col,
    CardBody, Card, CardTitle, CardSubtitle,
    Button,
    Input,
    Label,
    FormGroup, CustomInput
} from "reactstrap"
import { ConfirmAlert } from '../../../../helpers/ui/alert'
import { AvForm, AvGroup, AvInput, AvField, AvCheckboxGroup, AvCheckbox } from "availity-reactstrap-validation"
import CustomSelect from "../../../../helpers/ui/CustomSelect";

import { Link, useHistory, Redirect } from "react-router-dom"

import apiResponse from '../../../../services/apiResponse'

import UpdateBloc from './Blocs/UpdateBloc'

const typeOption = [
    { value: 1, label: 'Terlambat' },
    { value: 2, label: 'Pulang Cepat' }
]
const calculationOption = [
    { value: 1, label: 'Tunkin' },
    { value: 2, label: 'Honorarorium' }
]

class IndexView extends Component {

    updateBloc = new UpdateBloc();

    constructor(props) {
        super(props)
        this.state = {
            dataForm: {},
            detailData: {},
            uuid: new URLSearchParams(window.location.search).get('uuid'),
            gagal_txt : '',
            arrjamstart:[],
            arrjamend:[]
        }
    }
    
    loadDetail = async () => {
        await this.updateBloc.fetchDetail({uuid: this.state.uuid })
    }
    submitData = async () => {
        await this.updateBloc.fetchUpdate(this.state.dataForm)
    }
    checkData = async () => {
        await this.updateBloc.fetchCheck(this.state.dataForm)
    }
    
    handlerOnSubmit = (e, values) => {
        e.preventDefault()
        // console.log(values)
        // return 
        
        this.setState({
            dataForm: values,
            confirm: true
        })
    }
    
    confirmResponse = (response) => {
        let forState = {}
        this.setState({
            gagal_txt: "Gagal!"
        })
        switch(response) {
            case 'cancel':
        forState = {
            confirm: false
        }
        break;
        case 'confirm':
            forState = {
                loading: true,
                confirm: false
            }
            this.submitData()
            break;
            case 'success':
                forState = {
                    success: false,
                    redirect: true
                }
                break;
                case 'failed':
                    forState = {
                        failed: false
                    }
                    break;
                    default:       
                }
                this.setState(forState)
            }
                    
        componentDidMount() {
            // const queryParams = new URLSearchParams(window.location.search)
            // console.log(this.state.uuid)
            // this.loadDetail()
            this.updateBloc.detailChannel.subscribe((result) => {
                switch (result.status) {
                    case apiResponse.COMPLETED:
                        if(result.data.status) {
                            let response = result.data.response
                            console.log(response.cutting_category_start_time.split(":"))
                            this.setState({
                                detailData: response,
                                arrjamstart: response.cutting_category_start_time.split(":"),
                                arrjamend: response.cutting_category_end_time.split(":")
                            })
                        }
                        break
                    case apiResponse.ERROR:
                        break
                    default:
                    break
                    }
            })
            this.updateBloc.fetchDetail({uuid: this.state.uuid })
            this.updateBloc.createChannel.subscribe((result) => {
                switch (result.status) {
                    case apiResponse.COMPLETED:
                this.setState({
                    loading: false,
                    success: true,
                });
                break
                case apiResponse.ERROR:
                    this.setState({
                        gagal_txt: "Gagal!",
                        loading: false,
                        failed: true,
                    });
                    break
                default:
                break
                }
            })
        this.updateBloc.checkChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    console.log(result.data.response)
                    // this.setState({
                    //     loading: false,
                    //     success: true,
                    // });
                    if(result.data.response==0){
                        this.submitData()
                    }else{
                        this.setState({
                            gagal_txt: "Tanggal Hari Libur Sudah ada",
                            loading: false,
                            failed: true,
                        });
                    }
                    break
                case apiResponse.ERROR:
                    this.setState({
                        gagal_txt: "Gagal!",
                        loading: false,
                        failed: true,
                    });
                    break
                default:
                    break
            }
        })

       
    }
    
    render() {
        return (
            <Fragment>
                <Container fluid>
                    <Row>
                        <Col className="col-12">
                            <Card>
                                <CardBody>
                                    <CardTitle>Form Ubah Data Potongan Tunkin</CardTitle>
                                    <CardSubtitle className="mb-3">
                                        Ubah data Tunkin 
                                    </CardSubtitle>
                                    <hr />
                                    <AvForm
                                        className="needs-validation"
                                        onValidSubmit={(e, values) => this.handlerOnSubmit(e, values)}
                                    >
                                        <Row className="mb-3">
                                            <label
                                                htmlFor="fielCode"
                                                className="col-md-3 col-form-label"
                                            >
                                            Nama Potongan <span className="text-danger">*</span>
                                            </label>
                                            <Col md="3">
                                                <AvField
                                                    name="cutting_category_uuid"
                                                    type="hidden"
                                                    value={this.state.detailData.cutting_category_uuid}
                                                />
                                                <AvField
                                                    name="cutting_category_name"
                                                    placeholder="Nama Potongan..."
                                                    type="text"
                                                    errorMessage="Nama Potongan Wajib diisi"
                                                    className="form-control"
                                                    validate={{ required: { value: true } }}
                                                    id="cutting_category_name"
                                                    value={this.state.detailData.cutting_category_name}
                                                />
                                            </Col>
                                        </Row>
                                        <Row className="mb-3">
                                            <label
                                                htmlFor="fielCode"
                                                className="col-md-3 col-form-label"
                                            >
                                            Tipe Potongan <span className="text-danger">*</span>
                                            </label>
                                            <Col md="3">
                                                <CustomSelect 
                                                    name="cutting_category_type"
                                                    errorMessage="Pilih Urutan"
                                                    placeholder="Pilih Urutan"
                                                    options={typeOption}
                                                    isSearchable={false}
                                                    defaultValue={this.state.detailData.cutting_category_type}
                                                    // isAvForm={false}
                                                />
                                            </Col>
                                        </Row>
                                        
                                        <Row className="mb-3">
                                            <label
                                                htmlFor="fieldTitle"
                                                className="col-md-3 col-form-label"
                                            >
                                            Jam Mulai <span className="text-danger">*</span>
                                            </label>
                                            <Col md="1">
                                                <AvField
                                                    name="hour_start"
                                                    placeholder="00"
                                                    type="number"
                                                    errorMessage="Masukan Jam"
                                                    className="form-control"
                                                    validate={{ required: { value: true } }}
                                                    value={this.state.arrjamstart[0]}
                                                    id="hour"
                                                />
                                            </Col>
                                            <Col md="1">
                                                <AvField
                                                    name="minut_start"
                                                    placeholder="00"
                                                    type="number"
                                                    errorMessage="Masukan Menit"
                                                    className="form-control"
                                                    validate={{ required: { value: true } }}
                                                    value={this.state.arrjamstart[1]}
                                                    id="minut"
                                                />
                                            </Col>
                                            <Col md="1">
                                                <AvField
                                                    name="second_start"
                                                    placeholder="00"
                                                    type="number"
                                                    errorMessage="Masukan detik"
                                                    className="form-control"
                                                    validate={{ required: { value: true } }}
                                                    value={this.state.arrjamstart[2]}
                                                    id="second"
                                                />
                                            </Col>
                                        </Row>
                                        <Row className="mb-3">
                                            <label
                                                htmlFor="fieldTitle"
                                                className="col-md-3 col-form-label"
                                            >
                                            Jam Selesai <span className="text-danger">*</span>
                                            </label>
                                            <Col md="1">
                                                <AvField
                                                    name="hour_end"
                                                    placeholder="00"
                                                    type="number"
                                                    errorMessage="Masukan Jam"
                                                    className="form-control"
                                                    validate={{ required: { value: true } }}
                                                    value={this.state.arrjamend[0]}
                                                    id="hour_end"
                                                />
                                            </Col>
                                            <Col md="1">
                                                <AvField
                                                    name="minut_end"
                                                    placeholder="00"
                                                    type="number"
                                                    errorMessage="Masukan Menit"
                                                    className="form-control"
                                                    validate={{ required: { value: true } }}
                                                    value={this.state.arrjamend[1]}
                                                    id="minut_end"
                                                />
                                            </Col>
                                            <Col md="1">
                                                <AvField
                                                    name="second_end"
                                                    placeholder="00"
                                                    type="number"
                                                    errorMessage="Masukan detik"
                                                    className="form-control"
                                                    validate={{ required: { value: true } }}
                                                    value={this.state.arrjamend[2]}
                                                    id="second_end"
                                                />
                                            </Col>
                                        </Row>
                                        <Row className="mb-3">
                                            <label
                                                htmlFor="fielCode"
                                                className="col-md-3 col-form-label"
                                            >
                                            Persentase <span className="text-danger">*</span>
                                            </label>
                                            <Col md="3">
                                                <AvField
                                                    name="cutting_category_percentage"
                                                    placeholder="Persentase..."
                                                    type="number"
                                                    errorMessage="Persentase Wajib diisi"
                                                    className="form-control"
                                                    validate={{ required: { value: true } }}
                                                    id="cutting_category_percentage"
                                                    value={this.state.detailData.cutting_category_percentage}
                                                />
                                            </Col>
                                            <Col md="3">%</Col>
                                        </Row>
                                        <Row className="mb-3">
                                            <label
                                                htmlFor="fielCode"
                                                className="col-md-3 col-form-label"
                                            >
                                            Tipe Potongan <span className="text-danger">*</span>
                                            </label>
                                            <Col md="3">
                                                <CustomSelect 
                                                    name="cutting_category_calculation_type"
                                                    errorMessage="Pilih Urutan"
                                                    placeholder="Pilih Urutan"
                                                    options={calculationOption}
                                                    isSearchable={false}
                                                    defaultValue={this.state.detailData.cutting_category_calculation_type}
                                                    // isAvForm={false}
                                                />
                                            </Col>
                                        </Row>
                                        <Row className="mb-3">
                                            <Col md="3"></Col>
                                            <Col md="9">
                                                <Link to="/master/potongan_tunkin.html">
                                                    <Button color="danger"><i className="uil-arrow-left"></i> Kembali</Button>
                                                </Link>
                                                {' '}
                                                <Button color="success" type="submit">
                                                    <i className="uil-arrow-up-right"></i> Simpan
                                                </Button>
                                            </Col>
                                        </Row>
                                    </AvForm>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Container>
                <ConfirmAlert
                    confirmTitle="Konfirmasi!"
                    confirmInfo="Apakah anda yakin akan menyimpan data ini?"

                    loadingTitle="Mengirim data..."
                    loadingInfo="Tunggu beberapa saat"

                    successTitle="Berhasil!"
                    successInfo="Data berhasil disimpan"

                    // failedTitle="Gagal!"
                    failedTitle={this.state.gagal_txt}
                    failedInfo="Data gagal disimpan"

                    showConfirm={this.state.confirm}
                    showLoading={this.state.loading}
                    showSuccess={this.state.success}
                    showFailed={this.state.failed}

                    response={this.confirmResponse}
                />
                { this.state.redirect ?
                    <Redirect to='/master/potongan_tunkin.html'/>
                : null }
            </Fragment>
        )
    }

}

export default IndexView